import OfertarButton from '../common/OfertarButton';

const pillars = [
  {
    label: 'Nossa Visão',
    text: 'Levar cada pessoa a um relacionamento público e crescente com Jesus.',
  },
  {
    label: 'Nosso Propósito',
    text: 'Ser uma igreja grande para servir e pequena para se importar.',
  },
  {
    label: 'Nossa Missão',
    text: 'Alcançar 10% da nossa cidade através de um crescimento saudável e acolhedor.',
  },
];

const About = () => {
  return (
    <section id="about" className="py-24 bg-[#0d1526]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Cabeçalho */}
        <div className="text-center mb-16">
          <div className="section-label mx-auto w-fit">Nossa Igreja</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
            Nossa <span className="text-gradient">História</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto">
            Mais de seis décadas transformando vidas em Parnamirim e no mundo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-start">

          {/* Vídeo estilo reels */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute -inset-3 bg-yellow-500/8 rounded-3xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden w-full max-w-[300px] aspect-[9/16] ring-1 ring-white/8 shadow-2xl">
                <video
                  className="w-full h-full object-cover"
                  src="images/video_igreja.mp4"
                  controls
                  loop
                  playsInline
                >
                  Seu navegador não suporta vídeos.
                </video>
              </div>
            </div>
          </div>

          {/* Texto */}
          <div className="flex flex-col justify-center">
            <p className="text-gray-300 text-base leading-relaxed mb-10">
              Somos uma igreja com raízes sólidas e visão global. Há mais de seis décadas, a Lagoinha se dedica a expandir o Evangelho e transformar vidas. Como parte da <strong className="text-white">Lagoinha Global</strong>, somos uma família de quase 700 igrejas focadas em amar pessoas e servir à sociedade.
            </p>

            <div className="space-y-5">
              {pillars.map(({ label, text }) => (
                <div
                  key={label}
                  className="glass-card glass-card-hover card-shine rounded-xl p-5"
                >
                  <h4 className="text-yellow-500 font-bold uppercase text-xs tracking-widest mb-1.5">
                    {label}
                  </h4>
                  <p className="text-gray-300 text-sm leading-relaxed">{text}</p>
                </div>
              ))}
            </div>

            <p className="text-gray-600 mt-8 italic text-sm border-l-2 border-yellow-500/40 pl-4">
              "Seja você criança, jovem ou adulto: aqui é um lugar para todos."
            </p>
          </div>
        </div>

        <div className="md:hidden mt-10 flex justify-center">
          <OfertarButton className="w-full max-w-sm" />
        </div>
      </div>
    </section>
  );
};

export default About;
